/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { getgeneralsystemparameterDetails } from '../../../System/systemParameter/store/actions';
import {
  setAddGroup,
  setCompareData,
  setCreateGrpOpt,
  setGroupTabDataAction,
  setIntialContactDetails,
  setMainGroupDetailsAction,
  setMaintainGroupParticipationDatesAction,
  setSelectedClientAction,
  dispatchClearsuccessFail
} from '../store/group-action';
import GroupTableContainer from './TableContainer';
import './group.css';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { getUTCTimeStampMMDDYYYY } from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  dispatchContactDetailsGroup,
  dispatchExistingContactDetailsGroup,
} from '../../Plan/store/actions';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  checkActionAccessByRole,
  isReadOnly as readOnly,
} from '../../../../SharedModules/utilities/utilities';

function Group(props) {
  const dispatch = useDispatch();

  const generalSystemParameterDetails = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const particpationDates = useSelector(
    (state) => state.sharedState.GroupReducer.particpationDates
  );
  const reduxDataSearchScreen = useSelector(
    (state) => state.sharedState.GroupReducer.searchScreen
  );

  const groupDetails = useSelector(
    (state) => state.sharedState.GroupReducer.mainGroupDetails
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [fullScreenView, setFullScreenView] = useState(false);
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  const redirectToGroupMaintain = () => {
    const newDate = {
      newRecord: true,
      index:
        particpationDates && particpationDates.length
          ? particpationDates.length
          : 0,
      endDt: null,
      groupName: '',
      corrLinkId: null,
      clientGroupId: {
        startDt: null,
      },
      lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
      lastUpdateUserId: logInUser,
    };
    dispatch(dispatchContactDetailsGroup([]));
    dispatch(dispatchExistingContactDetailsGroup([]));
    dispatch(setAddGroup(true));
    dispatch(setMainGroupDetailsAction(null));
    dispatch(setMaintainGroupParticipationDatesAction([newDate]));
    dispatch(setCompareData({ details: null, data: [] }));
    dispatch(setIntialContactDetails({}));
    dispatch(setCreateGrpOpt(true));
    dispatch(dispatchClearsuccessFail());
    dispatch(
      setGroupTabDataAction({ tabValue: 'one', disableSaveAndCancel: false })
    );
    redirectURLLink(
      '/group-maintain',
      'Maintain Group',
      props.history,
      dispatch
    );
    dispatch(
      setSelectedClientAction({
        ...reduxDataSearchScreen,
        currentIndex: null,
      })
    );
  };

  useEffect(() => {
    dispatch(getgeneralsystemparameterDetails());
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    const ele = document.querySelector('.nav-item-active a .tab-title');
    if (ele) {
      ele.textContent = 'Client Group';
    }
  }, []);

  return (
    <div className="tabs-container group-table">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="Maintain" parent2="Group" />
      {!fullScreenView && (
        <div className="no-margin" style={{ width: '99%' }}>
          <div className="form-wrapper">
            <div className="mui-custom-form no-margin override-width-38">
              <fieldset className="custom-fieldset" style={{ width: '55%' }}>
                <legend className="same-font-family">Search Criteria</legend>

                <div className="form-wrapper db">
                  <div
                    className="sub-radio no-margin"
                    id="demo-row-radio-buttons-group-label"
                  >
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        defaultValue={
                          reduxDataSearchScreen?.state?.selectedClient ||
                          'Group'
                        }
                      >
                        <FormControlLabel
                          value="Rebate Program Code"
                          control={
                            <Radio
                              onChange={() => {
                                dispatch(
                                  setSelectedClientAction({
                                    ...reduxDataSearchScreen,
                                    state: {
                                      selectedClient: 'Rebate Program Code',
                                    },
                                  })
                                );
                              }}
                            />
                          }
                          label="Rebate Program Code"
                          data-test="rebate-program-code"
                        />
                        <FormControlLabel
                          value="Group"
                          control={
                            <Radio
                              onChange={() => {
                                dispatch(
                                  setSelectedClientAction({
                                    ...reduxDataSearchScreen,
                                    state: { selectedClient: 'Group' },
                                  })
                                );
                              }}
                            />
                          }
                          label="Group"
                          data-test="group"
                        />
                        <FormControlLabel
                          value="Client"
                          control={
                            <Radio
                              onChange={() => {
                                dispatch(
                                  setSelectedClientAction({
                                    ...reduxDataSearchScreen,
                                    state: { selectedClient: 'Client' },
                                  })
                                );
                              }}
                            />
                          }
                          label="Client"
                          data-test="client"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </fieldset>
            </div>

            <div
              className="float-right  hide-on-print"
              style={{ marginBottom: '10px', marginTop: '0.75rem' }}
            >
              {generalSystemParameterDetails?.[0]?.allowNewCgpInd === 1 && (
                <Button
                  className="btn-success same-font-family"
                  onClick={redirectToGroupMaintain}
                  disabled={isReadOnly || !isEnablebyRole}
                >
                  <SVGComponent iconName="Create-new-icon" />
                  {'  '} Create New Group
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
      <div>
        <GroupTableContainer
          fullScreenView={fullScreenView}
          setFullScreenView={setFullScreenView}
          selectedClient={reduxDataSearchScreen?.state?.selectedClient}
        />
      </div>
    </div>
  );
}
export default withRouter(Group);
